export default "__VITE_ASSET__nTVVZj2x__"